import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthSessionService } from '../services/auth-session.service';

export const teacherAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  // Any authenticated user may access teacher routes.
  // Role checks would block users when role fetch fails (e.g. stale token).
  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);

  return true;
};
